import { type OrderFeedbackQuestion } from '@hungryroot/rest/api/v2/customers/[id]/order_feedback_questions/get/get-customer-order-feedback-questions';
import { useOrderFeedbackAnswer } from './useOrderFeedbackAnswer';

export const usePostAnswer = ({
  data,
  type,
  expectedAnswers,
}: {
  data:
    | {
        results: OrderFeedbackQuestion[];
      }
    | undefined;
  type: 'amount' | 'delivery';
  expectedAnswers: Record<string, number>;
}) => {
  const { mutate: postAnswers } = useOrderFeedbackAnswer({
    type,
  });

  const orderId = data?.results?.[0]?.order_id;
  const questionId = data?.results?.[0]?.id;

  const postAnswer = (answerSlug: string) => {
    if (!orderId || !questionId) {
      return;
    }

    if (
      !data?.results[0].answers
        .map((a) => a.id)
        .includes(expectedAnswers[answerSlug])
    ) {
      // Unlike with value, because we need to conditionally handle these answers, we can't just blindly render the answers from admin to the UI.
      // These are likely to not ever change, but if for some reason the hardcoded answers on our side our wrong, things are not going to work.
      throw new Error(`Answer ${answerSlug} not found in expected answers.`);
    }

    postAnswers({
      orderId,
      answers: [
        {
          questionId,
          answerId: expectedAnswers[answerSlug],
        },
      ],
    });
  };

  return postAnswer;
};
